module.exports = __webpack_public_path__ + "img/Loading_r_20.329c1c37.png";